<div class="flex flex-row min-h-full" [ngClass]="authGuard.getThemeClass()">
  <nav class="hidden sm:flex flex-col relative flex-none w-60 shadow border-r-2"
       [ngClass]="authGuard.isAgentiumUser() ? 'bg-gradient-to-b from-black to-momentum-deep_purple' : 'bg-[--nav-bg-color]'" cdkMenu>

    <!-- Logo's -->
    <div class="py-4 px-8">
      <img *ngIf="authGuard.isBridgeUser()" ngSrc="../../../assets/bridge-insurance-logo-200.png" width="200" height="76" alt="Bridge Logo" priority="" />
      <img *ngIf="authGuard.isAgentiumUser() && !authGuard.isAdmin()" ngSrc="../../../assets/momentum-edge-logo.png" width="150" height="75" alt="Agentium Logo" priority="" />
      <img *ngIf="authGuard.isAgentiumUser() && authGuard.isAdmin()" ngSrc="../../../assets/momentum-edge-logo.png" width="150" height="75" alt="Agentium Logo" priority="" />
    </div>

    <!-- Dashboard -->
    @if (!authGuard.isBridgeUser() && !authGuard.isProducer() && !authGuard.isAdmin()) {
      <button class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
              cdkMenuItem
              routerLink="/admin/dashboard"
              routerLinkActive="active"
              ariaCurrentWhenActive="page">
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faHouseBlank" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Dashboard
      </button>
    }

    <!-- Agency Admin -->
    @if (authGuard.isAdmin()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Agency Admin</div>
    }

    <!-- Agency List -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faTableList" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Agency List
      </button>
    }

    <!-- Users -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faUsers" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Users
      </button>
    }

    <!-- Reviews -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faStar" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Reviews
      </button>
    }

    <!-- Verify URLs -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faLinkSimple" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Verify URLs
      </button>
    }

    <!-- Bridge Marketplace -->
    @if (authGuard.isBridgeUser() && authGuard.isCarrier()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Bridge Marketplace</div>
    }

    <!-- Opportunity Admin -->
    @if (authGuard.isAgentiumUser() && (authGuard.isAdmin() || authGuard.isAgencyAdmin())) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Opportunity Admin</div>
    }

    <!-- My Marketplace -->
    @if (authGuard.isProducer()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Referrals</div>
    }

    <!-- Referral Marketplace -->
    <button
      class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
      cdkMenuItem
      routerLink="/admin/all-referrals"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
    >
      <div class="absolute left-0 top-0 w-1 h-full button-select-indicator group-hover:bg-[--nav-btn-active-indication-color]"></div>
      <fa-icon [icon]="faCartShoppingFast" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Claim-it Marketplace
    </button>

    <!-- My Acquired Referrals -->
    @if (!authGuard.isAdmin()) {
      <button
        *ngIf="!authGuard.isAdmin()"
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/purchased-referrals"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator group-hover:bg-[--nav-btn-active-indication-color]"></div>
        <fa-icon [icon]="faBoxArchive" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Acquired Referrals
      </button>
    }

    <!-- Claim-It Transactions -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/purchased-referrals"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faUserTag" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Claim-It Transactions
      </button>
    }

    <!-- Marketplaces -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/marketplaces"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faShop" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Marketplaces
      </button>
    }

    <!-- Company Admin -->
    @if (authGuard.isAdmin()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Company Admin</div>
    }

    <!-- Companies -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faBuilding" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Companies
      </button>
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/state-associations"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator group-hover:bg-[--nav-btn-active-indication-color]"></div>
        <fa-icon [icon]="faBoxArchive" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>State Association
      </button>
    }

    <!-- Developer -->
    @if (authGuard.isAdmin()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Developer</div>
    }

    <!-- Feature Flags -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/feature-flags"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faFlag" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Feature Flags
      </button>
    }

    <!-- Mailgun Suppressions -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color] whitespace-nowrap"
        cdkMenuItem
        routerLink="/admin/mailgun-suppression"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faEnvelope" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Mailgun Suppressions
      </button>
    }

    <!-- Consumer SMS Campaign -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color] whitespace-nowrap"
        cdkMenuItem
        routerLink="/admin/consumer-sms-campaign"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faCommentSms" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Consumer SMS Campaign
      </button>
    }

    <!-- Consumer Email Campaign -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color] whitespace-nowrap"
        cdkMenuItem
        routerLink="/admin/consumer-email-campaign"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faPaperPlane" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Consumer Email Campaign
      </button>
    }

    <!-- Dynamic Phone -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faPhoneVolume" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Dynamic Phone
      </button>
    }

    <!-- Page Tagging -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
        routerLink="/admin/not-implemented"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
        <fa-icon [icon]="faHashtag" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Page Tagging
      </button>
    }

    @if (!authGuard.isAdmin()) {
      <div>
        <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Personal Settings</div>
        <button
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faFilter" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>
          <span *ngIf="authGuard.isCarrier()">Marketplace Appetite</span>
          <span *ngIf="!authGuard.isCarrier()">My Appetite</span>
        </button>
        <button
          *ngIf="!authGuard.isCarrier()"
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faAddressCard" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Account Info
        </button>
        <button
          *ngIf="authGuard.isCarrier()"
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faAddressCard" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Company Info
        </button>
        <button
          *ngIf="authGuard.isCarrier()"
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faUserCheck" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Appointed Agents
        </button>
        <button
          *ngIf="!authGuard.isCarrier()"
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faCreditCard" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Payment Method
        </button>
        <button
          *ngIf="!authGuard.isCarrier()"
          class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
          cdkMenuItem
        >
          <fa-icon [icon]="faBell" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Notifications
        </button>
      </div>
    }

    <!-- Analytics -->
    @if (authGuard.isCarrier()) {
      <div class="px-8 pt-4 pb-2 uppercase tracking-wider text-xs text-[--nav-subtitle-text-color]">Analytics</div>
    }

    <!-- Live Shoppers -->
    @if (authGuard.isCarrier()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
      >
        <fa-icon [icon]="faSignalStream" [fixedWidth]="true" class="px-2 text-[--nav-btn-icon-color] group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon>Live Shoppers
      </button>
    }

    <div *ngIf="authGuard.isAdmin()" class="h-10"></div>

    <!-- Help Desk -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
      >
        Help Desk
      </button>
    }

    <!-- New Features -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
      >
        New Features
      </button>
    }

    <!-- Pricing -->
    @if (authGuard.isAdmin()) {
      <button
        class="relative px-8 py-3 w-full text-left group text-[--nav-btn-text-color] hover:text-[--nav-btn-text-hover-color] bg-[--nav-btn-bg-color] hover:bg-[--nav-btn-bg-hover-color] active:text-[--nav-btn-text-hover-color] active:bg-[--nav-btn-bg-hover-color]"
        cdkMenuItem
      >
        Pricing
      </button>
    }
    <div class="mt-auto mb-12 px-4">
      <img *ngIf="authGuard.isBridgeUser()" ngSrc="../../../assets/tc-momentum-lockup-logo.png" class="relative -left-[5px] mb-2" width="200" height="20" alt="Agentium Logo" priority="" />
      <img *ngIf="authGuard.isAgentiumUser()" ngSrc="../../../assets/TC-Momentum-lockup-white.png" class="relative -left-[5px] mb-2" width="200" height="20" alt="Agentium Logo" priority="" />
      <div class="mb-3">
        <div  class="text-[--nav-btn-text-color] text-xs">Copyright &copy;{{ currentYear() }}, Consumer Agent Portal, LLC. <span class="text-nowrap">All rights reserved.</span>
        </div>
      </div>
      <div class="text-[--nav-btn-text-color] text-xs">
        <a href="#" class="iubenda-cs-preferences-link hover:underline text-nowrap mb-1 block">Privacy Policy</a>
        <span class="iubenda-cs-uspr-link hidden"></span>
        <a href="https://trustedchoice-content.s3.amazonaws.com/terms-and-conditions/Master-Service-Agreement.pdf" target="_blank" class="hover:underline text-nowrap">Agent Master Agreement</a>
      </div>
    </div>
  </nav>

  <div class="flex-grow overflow-auto">
    <nav class="h-16  flex col-auto justify-between sticky top-0 z-50 sm:z-50 content-center"
         [ngClass]="authGuard.isAgentiumUser() ? 'bg-gradient-to-b from-black to-momentum-deep_purple sm:from-white sm:to-white' : 'bg-[--nav-bg-color]'" cdkMenu>
      <h2 class="hidden sm:block pl-6 content-center">{{ this.stateManagementService.pageHeading() || "Claim-it Marketplace" }}</h2>
      <div class="hidden sm:flex flex-row items-center p-6 text-slate-600 text-base">
        <div class="relative inline-block text-left" #dropdownWrapper>
          <button
            class="inline-flex justify-center w-full rounded-md items-center hover:bg-agentium_white-backdrop px-2"
            [ngClass]="{ 'bg-agentium_white-backdrop': isUserProfileDropdownOpen }"
            (click)="toggleDropdown()"
          >
            <div class="content-center flex items-center pr-2">
              <fa-icon [icon]="faCircleUser" [fixedWidth]="true" class="py-2 pr-2 content-center text-momentum-deep_purple" size="xl"></fa-icon>
              <div *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && !authGuard.isAgentiumUser()">{{ user.firstName + " " + user.lastName }}</div>
              <div *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && authGuard.isAgentiumUser()">{{ user.firstName + " " + user.lastName }}</div>
              <div *ngIf="user != null && authGuard.isProducer() && !authGuard.isAgentiumUser()">{{ user.firstName + " " + user.lastName }}</div>
              <div *ngIf="user != null && authGuard.isProducer() && authGuard.isAgentiumUser()">{{ user.firstName + " " + user.lastName }}</div>
              <div *ngIf="user != null && authGuard.isAgencyAdmin()">{{ user.firstName + " " + user.lastName }}</div>
            </div>
            <fa-icon [ngClass]="{ 'rotate-180': isUserProfileDropdownOpen }" [icon]="faChevronDown" size="sm"></fa-icon>
          </button>

          <div
            *ngIf="isUserProfileDropdownOpen"
            class="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 min-w-[250px]"
          >
            <div>

              <div class="py-4 cursor-default" *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && !authGuard.isAgentiumUser()">
                <div class="px-4">
                  <div class="text-sm text-agentium_gray-text">Bridge Insurance Company</div>
                  <div class="text-gray-400 mt-6 uppercase tracking-wider text-xs">Role</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="authGuard.isAdmin()">Admin</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="authGuard.isCarrier()">Carrier</div>
                  <hr class="border-gray-200 my-4">
                </div>

                <div>
                  <div class="text-gray-400 uppercase tracking-wider text-xs mb-1 px-4">Need Assistance</div>
                  <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-[--nav-btn-icon-color] text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Help Desk</span></a>
                  <a (click)="authGuard.logout()" class="block mt-6 cursor-pointer hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Logout</span></a>
                </div>
              </div>

              <div class="py-4 cursor-default" *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && authGuard.isAgentiumUser()">
                <div class="px-4">
                  <div class="text-sm text-agentium_gray-text">Momentum Edge</div>
                  <div class="text-gray-400 mt-6 uppercase tracking-wider text-xs">Role</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="authGuard.isAdmin()">Admin</div>
                  <div class="text-smtext-agentium_gray-text" *ngIf="authGuard.isCarrier()">Carrier</div>
                  <hr class="border-gray-200 my-4">
                </div>

                <div>
                  <div class="text-gray-400 uppercase tracking-wider text-xs mb-1 px-4">Need Assistance</div>
                  <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-[--nav-btn-icon-color] text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Help Desk</span></a>
                  <a (click)="authGuard.logout()" class="block mt-6 cursor-pointer hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Logout</span></a>
                </div>
              </div>

              <div class="py-4 cursor-default" *ngIf="user != null && authGuard.isProducer()">
                <div class="px-4">
                  <div class="text-gray-400 text-xs uppercase tracking-wider mb-1">Agency</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="user.agencyName">{{ user.agencyName }}</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="user.city && user.state">{{ user.city | titlecase}}, {{ user.state | uppercase }}</div>
                  <div class="text-gray-400 mt-6 uppercase tracking-wider text-xs">Role</div>
                  <div class="text-sm text-agentium_gray-text mb-1">Producer</div>
                  <hr class="border-gray-200 my-4">
                </div>

                <div>
                  <div class="text-gray-400 uppercase tracking-wider text-xs mb-1 px-4">Need Assistance</div>
                  <a [href]="environment.wwwUrl + '/advantage/contact-us/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faSquareInfo" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-agentium_gray-text text-sm group-hover:text-agentium_gray-headline">Contact Us</span></a>
                  <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-[--nav-btn-icon-color] text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Help Desk</span></a>
                  <a (click)="authGuard.logout()" class="block mt-6 cursor-pointer hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Logout</span></a>
                </div>
              </div>

              <div class="py-4 cursor-default" *ngIf="user != null && authGuard.isAgencyAdmin()">
                <div class="px-4">
                  <div class="text-gray-400 text-xs uppercase tracking-wider mb-1">Agency</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="user.agencyName">{{ user.agencyName }}</div>
                  <div class="text-sm text-agentium_gray-text" *ngIf="user.city && user.state">{{ user.city | titlecase}}, {{ user.state | uppercase }}</div>
                  <div class="text-gray-400 mt-6 uppercase tracking-wider text-xs">Role</div>
                  <div class="text-sm text-agentium_gray-text">Agency Admin</div>
                  <hr class="border-gray-200 my-4">
                </div>

                <div>
                  <div class="text-gray-400 uppercase tracking-wider text-xs mb-1 px-4">Need Assistance</div>
                  <a [href]="environment.wwwUrl + '/advantage/contact-us/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faSquareInfo" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-agentium_gray-text text-sm group-hover:text-agentium_gray-headline">Contact Us</span></a>
                  <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-[--nav-btn-icon-color] text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Help Desk</span></a>
                  <a (click)="authGuard.logout()" class="block mt-6 cursor-pointer hover:bg-agentium_white-backdrop px-4 py-1 group"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-momentum-deep_purple" size="lg"></fa-icon><span class="text-sm text-agentium_gray-text group-hover:text-agentium_gray-headline">Logout</span></a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


<!--      mobile nav-->
      <div class="sm:hidden my-auto">
        <img *ngIf="authGuard.isBridgeUser()" ngSrc="../../../assets/bridge-insurance-logo-200.png" width="160" height="63" alt="Bridge Logo" priority="" />
        <img *ngIf="authGuard.isAgentiumUser() && !authGuard.isAdmin()" class="pl-4" ngSrc="../../../assets/momentum-edge-logo.png" width="175" height="37" alt="Momentum Edge Logo" priority="" />
        <img *ngIf="authGuard.isAgentiumUser() && authGuard.isAdmin()" class="pl-4" ngSrc="../../../assets/momentum-edge-logo.png" width="200" height="37" alt="Momentum Edge Logo" priority="" />
      </div>

            <details class="cursor-pointer list-none sm:hidden flex items-center mr-3" name="nav-item">
      <summary class="list-none">
        <div
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg relative z-50  bg-transparent"
        >
          <svg class="w-5 h-5 stroke-[--nav-btn-text-color]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 17 14">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
          </svg>
        </div>
      </summary>


      <div class="mobile-nav absolute top-[65px] bg-white left-0 right-0 mx-auto rounded-xl shadow-xl">
        <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">
          <summary class="list-none flex items-center"> <fa-icon [icon]="faCircleUser" [fixedWidth]="true" class="pr-2 text-momentum-deep_purple" size="lg">

          </fa-icon><div>
            <div *ngIf="user != null">{{ user.firstName + " " + user.lastName }}</div>
          </div><span></span></summary>
        </details>
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white left-0 right-0 mx-auto p-5 rounded-b-lg shadow-xl cursor-default">
            <div  *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && !authGuard.isAgentiumUser()">
                   <div>
                     <div class="text-base text-agentium_gray-text">Bridge Insurance Company</div>
                     <div class="text-gray-400 mt-6 text-sm">Role</div>
                     <div class="text-base text-agentium_gray-text" *ngIf="authGuard.isAdmin()">Admin</div>
                     <div class="text-base text-agentium_gray-text" *ngIf="authGuard.isCarrier()">Carrier</div>
                   </div>
              <hr class="border-agentium_gray-text my-4">
              <div>
                <div class="text-gray-400">Need Assistance</div>
                <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block" target="_blank"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Help Desk</span></a>
                <a (click)="authGuard.logout()"  class="block mt-6"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Logout</span></a>
              </div>
            </div>

            <div *ngIf="user != null && (authGuard.isAdmin() || authGuard.isCarrier()) && authGuard.isAgentiumUser()">
              <div>
                <div class="text-base text-agentium_gray-text">Momentum Edge</div>
                <div class="text-gray-400 mt-6 text-sm">Role</div>
                <div class="text-base text-agentium_gray-text" *ngIf="authGuard.isAdmin()">Admin</div>
                <div class="text-base text-agentium_gray-text" *ngIf="authGuard.isCarrier()">Carrier</div>
              </div>
              <hr class="border-agentium_gray-text my-4">
              <div>
                <div class="text-gray-400">Need Assistance</div>
                <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block" target="_blank"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Help Desk</span></a>
                <a (click)="authGuard.logout()"  class="block mt-6"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Logout</span></a>
              </div>
            </div>

            <div *ngIf="user != null && authGuard.isProducer()">
              <div>
                <div class="text-gray-400 text-sm">Agency</div>
                <div class="text-base text-agentium_gray-text" *ngIf="user.agencyName">{{ user.agencyName }}</div>
                <div class="text-base text-agentium_gray-text" *ngIf="user.city && user.state">{{ user.city | titlecase}}, {{ user.state | uppercase }}</div>
                <div class="text-gray-400 mt-6 text-sm">Role</div>
                <div class="text-base text-agentium_gray-text">Producer</div>
              </div>
              <hr class="border-agentium_gray-text my-4">
              <div>
                <div class="text-gray-400">Need Assistance</div>
                <a [href]="environment.wwwUrl + '/advantage/contact-us/'"class="block mb-2" target="_blank"><fa-icon [icon]="faSquareInfo" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color] text-base">Contact Us</span></a>
                <a [href]="environment.wwwUrl + '/advantage/help-desk/'" class="block" target="_blank"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Help Desk</span></a>
                <a (click)="authGuard.logout()" class="block mt-6"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Logout</span></a>
              </div>
            </div>

            <div *ngIf="user != null && authGuard.isAgencyAdmin()">
              <div>
                <div class="text-gray-400 text-sm">Agency</div>
                <div class="text-base text-agentium_gray-text" *ngIf="user.agencyName">{{ user.agencyName }}</div>
                <div class="text-base text-agentium_gray-text" *ngIf="user.city && user.state">{{ user.city | titlecase}}, {{ user.state | uppercase }}</div>
                <div class="text-gray-400 mt-6 text-sm">Role</div>
                <div class="text-base text-agentium_gray-text">Agency Admin</div>
              </div>
              <hr class="border-agentium_gray-text my-4">
              <div>
                <div class="text-gray-400">Need Assistance</div>
                <a [href]="environment.wwwUrl + '/advantage/contact-us/'"class="block mb-2" target="_blank"><fa-icon [icon]="faSquareInfo" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color] text-base">Contact Us</span></a>
                <a [href]="environment.wwwUrl + '/advantage/help-desk/'" target="_blank" class="block"><fa-icon [icon]="faMessages" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Help Desk</span></a>
                <a (click)="authGuard.logout()"  class="block mt-6"><fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" class="pr-2 text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]" size="lg"></fa-icon><span class="text-agentium_gray-text group-hover:text-[--nav-btn-icon-hover-color]  text-base">Logout</span></a>
              </div>
            </div>
          </div>
        </div>

        @if (!authGuard.isBridgeUser() && !authGuard.isProducer() && !authGuard.isAdmin()) {
          <a  class="text-base block sm:text-xl font-medium bg-white pl-5 pr-10 py-2.5 text-agentium_gray-headline "
              cdkMenuItem
              routerLink="/admin/dashboard"
              routerLinkActive="active"
              ariaCurrentWhenActive="page">
           Dashboard
          </a>
        }


        @if (authGuard.isAdmin()) {
          <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">
            <summary class="list-none flex">Agency Admin<span></span></summary>
          </details>
        }
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">
              <!-- Agency List -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faTableList" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Agency List
                </button>
              }

              <!-- Users -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faUsers" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Users
                </button>
              }

              <!-- Reviews -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faStar" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Reviews
                </button>
              }

              <!-- Verify URLs -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faLinkSimple" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Verify URLs
                </button>
              }
            </div>
          </div>
        </div>

        <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">

          <!-- Bridge Marketplace -->
          @if (authGuard.isBridgeUser() && authGuard.isCarrier()) {
            <summary class="list-none flex">Bridge Marketplace<span></span></summary>
          }

          <!-- Bridge Marketplace -->
          @if (authGuard.isAgentiumUser() && authGuard.isCarrier()) {
            <summary class="list-none flex">Agentium Marketplace<span></span></summary>
          }

          <!-- My Marketplace -->
          @if (authGuard.isProducer()) {
            <summary class="list-none flex">Referrals<span></span></summary>
          }

          <!-- My Marketplace -->
          @if (authGuard.isAgentiumUser() && (authGuard.isAdmin() || authGuard.isAgencyAdmin()))  {
            <summary class="list-none flex">Opportunity Admin<span></span></summary>
          }

        </details>
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">
              <a
                class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                cdkMenuItem
                routerLink="/admin/all-referrals"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
              >
                <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                <fa-icon [icon]="faCartShoppingFast" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Claim-It Marketplace
              </a>

              <!-- Claim-It Transactions -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/purchased-referrals"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faUserTag" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Claim-It Transactions
                </button>
              }

              <!-- Marketplaces -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/marketplaces"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faShop" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Marketplaces
                </button>
              }

              <!-- My Acquired Referrals -->
              @if (!authGuard.isAdmin()) {
                <button
                  *ngIf="!authGuard.isAdmin()"
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/purchased-referrals"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faBoxArchive" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Acquired Referrals
                </button>
              }

            </div>
          </div>
        </div>

        @if (authGuard.isAdmin()) {
          <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">
            <summary class="list-none flex">Company Admin<span></span></summary>
          </details>
        }
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">
              <!-- Companies -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faBuilding" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Companies
                </button>
              }
            </div>
          </div>
        </div>

        @if (authGuard.isAdmin()) {
          <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">
            <summary class="list-none flex">Developer<span></span></summary>
          </details>
        }
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">

              <!-- Feature Flags -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/feature-flags"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faFlag" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Feature Flags
                </button>
              }

              <!-- Consumer SMS Campaign -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/consumer-sms-campaign"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faCommentSms" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Consumer SMS Campaign
                </button>
              }

              <!-- Consumer Email Campaign -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/consumer-email-campaign"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faPaperPlane" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Consumer Email Campaign
                </button>
              }

              <!-- Dynamic Phone -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faPhoneVolume" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Dynamic Phone
                </button>
              }

              <!-- Page Tagging -->
              @if (authGuard.isAdmin()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                  routerLink="/admin/not-implemented"
                  routerLinkActive="active"
                  ariaCurrentWhenActive="page"
                >
                  <div class="absolute left-0 top-0 w-1 h-full button-select-indicator"></div>
                  <fa-icon [icon]="faHashtag" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Page Tagging
                </button>
              }
            </div>
          </div>
        </div>

        @if (!authGuard.isAdmin()) {
        <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">
            <summary class="list-none flex">Personal Settings<span></span></summary>
        </details>
        }
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">
              @if (!authGuard.isAdmin()) {
                <div>
                  <button
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faFilter" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>
                    <span *ngIf="authGuard.isCarrier()">Marketplace Appetite</span>
                    <span *ngIf="!authGuard.isCarrier()">My Appetite</span>
                  </button>
                  <button
                    *ngIf="!authGuard.isCarrier()"
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faAddressCard" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Account Info
                  </button>
                  <button
                    *ngIf="authGuard.isCarrier()"
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faAddressCard" [fixedWidth]="true" class="px-2 text-agentium_gray-text " size="lg"></fa-icon>Company Info
                  </button>
                  <button
                    *ngIf="authGuard.isCarrier()"
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faUserCheck" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Appointed Agents
                  </button>
                  <button
                    *ngIf="!authGuard.isCarrier()"
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faCreditCard" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Payment Method
                  </button>
                  <button
                    *ngIf="!authGuard.isCarrier()"
                    class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                    cdkMenuItem
                  >
                    <fa-icon [icon]="faBell" [fixedWidth]="true" class="px-2 text-agentium_gray-text " size="lg"></fa-icon>Notifications
                  </button>
                </div>
              }
            </div>
          </div>
        </div>

        @if (authGuard.isCarrier()) {
        <details class="cursor-pointer list-none hover:bg-agentium_blue-light" name="mobile-nav-item">

          <!-- Analytics -->
          @if (authGuard.isCarrier()) {
            <summary class="list-none flex">Analytics<span></span></summary>
          }


        </details>
        <div role="definition" class="mobile-nav-content">
          <div class="bg-white !p-0 left-0 right-0 mx-auto rounded-b-lg shadow-xl cursor-default">
            <div class="flex flex-col text-base">
              <!-- Live Shoppers -->
              @if (authGuard.isCarrier()) {
                <button
                  class="relative px-8 py-3 w-full text-left group text-agentium_gray-text hover:bg-agentium_white-backdrop  active:text-agentium_gray-headline active:bg-agentium_white-backdrop"
                  cdkMenuItem
                >
                  <fa-icon [icon]="faSignalStream" [fixedWidth]="true" class="px-2 text-agentium_gray-text" size="lg"></fa-icon>Live Shoppers
                </button>
              }

            </div>
          </div>
        </div>
        }
        @if (authGuard.isAdmin()) {

        <a [href]="environment.wwwUrl + '/advantage/help-desk/'" target="_blank">
          <div class="text-base sm:text-xl font-medium bg-white pl-5 pr-10 py-2.5 text-agentium_gray-headline">About Us</div>
        </a>
        <a href="#" target="_blank">
          <div class="text-base sm:text-xl font-medium bg-white pl-5 pr-10 py-2.5 text-agentium_gray-headline">New Features</div>
        </a>
        <a href="#" target="_blank">
          <div class="text-base sm:text-xl font-medium bg-white pl-5 pr-10 py-2.5 text-agentium_gray-headline">Pricing</div>
        </a>
        }
      </div>
    </details>
    </nav>
    <div class="mx-auto">
      <router-outlet></router-outlet>
    </div>
    <!--  mobile footer-->
    <div class="block sm:hidden px-4 mb-6 text-center">
      <div><img ngSrc="../../../assets/tc-momentum-lockup-logo.png" class="mx-auto mb-2" width="250" height="50" alt="TrustedChoice.com & Momentum Logo" priority="" /></div>
        <div class="text-agentium_gray-text text-xs">Copyright &copy;{{ currentYear() }}, Consumer Agent Portal, LLC. <span class="text-nowrap">All rights reserved.</span>
        </div>

      <div class="flex justify-center flex-wrap text-agentium_gray-text text-xs">
        <a href="#" class="iubenda-cs-preferences-link hover:underline text-nowrap mr-3">Privacy Policy</a>
        <span class="iubenda-cs-uspr-link hidden"></span>
        <a href="https://trustedchoice-content.s3.amazonaws.com/terms-and-conditions/Master-Service-Agreement.pdf" target="_blank" class="hover:underline text-nowrap">Agent Master Agreement</a>
      </div>
    </div>
  </div>
</div>
